import React from "react";
import {
    FiniteListWithAsyncLoaderAbstract, ListProps
} from "shared/components/Components";
import {useMercuryContext} from "../context";

class PoTypeFilter extends FiniteListWithAsyncLoaderAbstract {

    async fetch() {
        const { data } = await this.props.context.gpClient.get("/google-gp-v1/PoType");
        return data.map( ( item:any ) => {
            return {
                title: item.title,
                value: item._id
            }
        })
    }
}

export default (props:ListProps) => {
    const context = useMercuryContext();
    return <PoTypeFilter context={context} {...props} />
}
